export class GlobalError extends Error {
  key: string
  constructor(key: string, message: string) {
    super(message)
    this.key = key
  }
}
